import { render, staticRenderFns } from "./ViewArticleText.vue?vue&type=template&id=09f444ba&scoped=true"
import script from "./ViewArticleText.vue?vue&type=script&lang=js"
export * from "./ViewArticleText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f444ba",
  null
  
)

export default component.exports